import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoCheckboxConfig extends IEoFormControlConfig {
  type?: 'checkbox';
  checkboxStyleClass?: string;
  value?: any;
}

export class EoCheckboxConfig
  extends EoFormControlConfig
  implements IEoCheckboxConfig
{
  override type?: 'checkbox';
  checkboxStyleClass?: string;
  value?: any;

  constructor();
  constructor(obj: IEoCheckboxConfig);
  constructor(obj?: IEoCheckboxConfig) {
    super(obj as IEoFormControlConfig);
    this.type = 'checkbox';
    if (obj?.value) this.value = obj.value;
  }
}
